import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import RelojCuentaAtras from '../components/RelojCuentaAtras'
import axios from 'axios'

function PerfilPanel() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [perfil, setPerfil] = useState(null)

  useEffect(() => {
    const perfiles = JSON.parse(localStorage.getItem('perfiles')) || []
    const p = perfiles.find(perfil => perfil.id === id)
    if (!p) return navigate('/dashboard')
    setPerfil(p)
  }, [id])

  return (
    <div>
      <h2>Perfil: {perfil?.nombre}</h2>
      <RelojCuentaAtras fechaExp={perfil?.fechaExp} />
      <div>
        <button onClick={() => navigate(`/dashboard`)}>Volver</button>
      </div>
    </div>
  )
}

export default PerfilPanel
